import { SettlementInfoParams } from '@models/payload/settlment';
import { TablePageParams } from '@models/payload/table';
import { ropoloRequest } from '@services/axios';

const getSettlementsService = async (params: TablePageParams) => (await ropoloRequest.settlementsList(params))?.data;

const getSettlementsOrderInfoById = async (params: SettlementInfoParams) =>
  (await ropoloRequest.settlementsInfoList(params))?.data;

const getSettlementsInfoById = async (id: string) => (await ropoloRequest.settlementsInfoDetail(id))?.data;

const getSettlementExcel = async (id: string) => (await ropoloRequest.settlementsInfoExcelDetail(id))?.data;

export { getSettlementsService, getSettlementsInfoById, getSettlementsOrderInfoById, getSettlementExcel };
